import {Component, Input} from '@angular/core';
import {AbstractComponent} from "@components";
import {Country, EventItem, Lookups} from "@model";
import {environment} from "@environment";

@Component({
  selector: 'app-live-results',
  templateUrl: './live-results.component.html',
  styleUrls: ['./live-results.component.scss']
})
export class LiveResultsComponent extends AbstractComponent {
  @Input() liveEvents: EventItem[] = []
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  now: Date = new Date(); // Current date and time
}
